// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OYch","index":"styles_index__I0mdr"};